"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.Improvements = exports.isOpenImprovement = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = __importDefault(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var lookup_1 = require("../code-bench-panel/lookup/lookup");
var svg_icons_1 = require("../svgs/svg-icons");
var conditional_1 = require("../conditional/conditional");
var menu_button_1 = require("../menu-button/menu-button");
var menu_item_1 = require("../menu-button/menu-item");
var improvement_provider_1 = require("./improvement-provider");
var improvement_charge_1 = require("./improvement-charge");
var ui_common_1 = require("@codametrix/ui-common");
var DocumentStatus = ui_common_1.commonEnums.DocumentStatus;
var isOpenImprovement = function (improvement) {
    var _a, _b, _c;
    var requiredImprovement = (_a = improvement === null || improvement === void 0 ? void 0 : improvement.provider_query) !== null && _a !== void 0 ? _a : false;
    var noProviderImprovement = requiredImprovement && ((_b = improvement === null || improvement === void 0 ? void 0 : improvement.providers) === null || _b === void 0 ? void 0 : _b.length) === 0;
    var openImprovement = requiredImprovement &&
        ((_c = improvement === null || improvement === void 0 ? void 0 : improvement.providers) === null || _c === void 0 ? void 0 : _c.some(function (provider) { return (provider === null || provider === void 0 ? void 0 : provider.provider_query_status) === DocumentStatus.OPEN; }));
    return noProviderImprovement
        ? 'NO_PROVIDER'
        : openImprovement
            ? 'OPEN_REASON'
            : 'OTHERS';
};
exports.isOpenImprovement = isOpenImprovement;
// ---------------- utilities ----------------- //
/**
 * Formatting for the auto-complete search
 * @param activeIdx
 * @param entity
 * @param idx
 * @returns
 */
var resultFormatter = function (activeIdx, entity, idx) {
    var selectable = true;
    var styleClasses = [
        'search-result',
        {
            'result-unselectable': true
        }
    ];
    return ((0, jsx_runtime_1.jsxs)("div", __assign({ "data-idx": idx, className: (0, classnames_1["default"])(styleClasses), draggable: true }, { children: [(0, jsx_runtime_1.jsx)("div", __assign({ className: "col-label search-label" }, { children: entity['Error Code'] })), (0, jsx_runtime_1.jsx)("div", __assign({ className: "col-code-description" }, { children: entity['Documentation Improvement Opportunity Description'] }))] }), idx));
};
/**
 * Retrieve item from the search results.  Used to pass to the onAdd handler.
 * @param row
 * @param selectElement
 * @param searchResults
 * @returns
 */
var getSelectionData = function (row, selectElement, searchResults) {
    var item = row.attributes.getNamedItem('data-idx');
    if (!item)
        return;
    return searchResults[item.value];
};
var shouldShowResults = function (lookupState) {
    var _a;
    var active = lookupState.active, searching = lookupState.searching, codeQuery = lookupState.codeQuery;
    if (!active) {
        return false;
    }
    if (searching) {
        return true;
    }
    // one character names are displayable.
    return ((_a = codeQuery === null || codeQuery === void 0 ? void 0 : codeQuery.text) !== null && _a !== void 0 ? _a : '').length >= 1;
};
// ---------------- React Components ----------------- //
var ImprovementMenu = function (_a) {
    var showAddProvider = _a.showAddProvider, onAddProvider = _a.onAddProvider, onDeleteImprovement = _a.onDeleteImprovement;
    var icon = ((0, jsx_runtime_1.jsx)(svg_icons_1.CMXIcon, { svgIconName: "BiomeVerticalMenu", svgIconClass: "improvement-menu-button", svgIconSize: "16" }));
    return ((0, jsx_runtime_1.jsxs)(menu_button_1.MenuButton, __assign({ icon: icon }, { children: [!showAddProvider && ((0, jsx_runtime_1.jsx)(menu_item_1.MenuItem, __assign({ onSelect: onAddProvider }, { children: "Add provider" }))), (0, jsx_runtime_1.jsx)(menu_item_1.MenuItem, __assign({ onSelect: onDeleteImprovement }, { children: "Delete" }))] })));
};
var Improvement = /** @class */ (function (_super) {
    __extends(Improvement, _super);
    function Improvement(props) {
        var _this = _super.call(this, props) || this;
        _this.providerQueryIcon = function (improvement) {
            return improvement.provider_query ? ((0, jsx_runtime_1.jsx)(svg_icons_1.CMXIcon, { svgIconName: "BiomeVWErrorSVG20", svgIconClass: "improvement-required", svgTitleText: "Provider query is required" })) : ((0, jsx_runtime_1.jsx)(svg_icons_1.CMXIcon, { svgIconName: "BiomeReports", svgIconClass: "improvement-not-required", svgTitleText: "Provider query is not required" }));
        };
        _this.onImprovementDelete = function (ev) {
            ev.preventDefault();
            _this.props.onImprovementRemove(_this.props.improvement);
        };
        _this.onAddProvider = function (ev) {
            _this.setState({ showAddProvider: !_this.state.showAddProvider });
        };
        _this.state = {
            showAddProvider: props.improvement.providers.length === 0
        };
        _this.onImprovementDelete = _this.onImprovementDelete.bind(_this);
        _this.onAddProvider = _this.onAddProvider.bind(_this);
        return _this;
    }
    Improvement.prototype.componentDidUpdate = function (prevProps) {
        if (prevProps.improvement.providers.length !==
            this.props.improvement.providers.length) {
            this.setState({
                showAddProvider: this.props.improvement.providers.length === 0
            });
        }
    };
    Improvement.prototype.render = function () {
        return ((0, jsx_runtime_1.jsx)(conditional_1.Conditional, __assign({ some: [
                !this.props.showUnresolved,
                this.props.showUnresolved &&
                    (0, exports.isOpenImprovement)(this.props.improvement) !== 'OTHERS'
            ] }, { children: (0, jsx_runtime_1.jsxs)("div", __assign({ className: "improvement qa-improvement" }, { children: [(0, jsx_runtime_1.jsxs)("div", __assign({ className: "improvement-row" }, { children: [(0, jsx_runtime_1.jsxs)("div", __assign({ className: "improvement-no-actions" }, { children: [(0, jsx_runtime_1.jsx)("div", __assign({ className: "improvement-icon" }, { children: this.providerQueryIcon(this.props.improvement) })), (0, jsx_runtime_1.jsxs)("div", __assign({ className: "improvement-text" }, { children: [(0, jsx_runtime_1.jsxs)("span", __assign({ className: "improvement-code" }, { children: [(0, jsx_runtime_1.jsxs)("b", { children: [this.props.improvement.code, ":"] }), ' '] })), (0, jsx_runtime_1.jsx)("span", __assign({ className: "improvement-description" }, { children: this.props.improvement.description }))] }))] })), (0, jsx_runtime_1.jsx)("div", __assign({ className: "improvement-actions" }, { children: (0, jsx_runtime_1.jsx)(conditional_1.Conditional, __assign({}, this.props.improvementsAction, { children: (0, jsx_runtime_1.jsx)(ImprovementMenu, { showAddProvider: this.state.showAddProvider, onAddProvider: this.onAddProvider, onDeleteImprovement: this.onImprovementDelete }) })) }))] })), (0, jsx_runtime_1.jsxs)("div", __assign({ className: "improvement-body" }, { children: [(0, jsx_runtime_1.jsx)("div", __assign({ className: "provider-rows" }, { children: (0, jsx_runtime_1.jsx)(improvement_provider_1.ImprovementProviders, { improvement: this.props.improvement, improvementsAction: this.props.improvementsAction, processInstance: this.props.processInstance, onProviderRemove: this.props.onProviderRemove, onProviderUpdate: this.props.onProviderUpdate }) })), (0, jsx_runtime_1.jsx)(conditional_1.Conditional, __assign({}, this.props.improvementsAction, { children: this.state.showAddProvider && ((0, jsx_runtime_1.jsxs)("div", __assign({ className: "provider-search" }, { children: [(0, jsx_runtime_1.jsx)(improvement_provider_1.ImprovementProviderSearch, { improvement: this.props.improvement, improvementsAction: this.props.improvementsAction, organization: this.props.organization, processInstance: this.props.processInstance, providerSearchResults: this.props.providerSearchResults, onProviderAdd: this.props.onProviderAdd, onProviderSearch: this.props.onProviderSearch, showAmplifyFeedback: this.props.showAmplifyFeedback }), (0, jsx_runtime_1.jsx)(svg_icons_1.CMXIcon, { svgIconName: "BiomeChevronDownSVG20", svgIconSize: "20", svgIconClass: "select-checvron" })] }))) })), (0, jsx_runtime_1.jsx)(improvement_charge_1.ImprovementCharge, { improvement: this.props.improvement, improvementsAction: this.props.improvementsAction, processInstance: this.props.processInstance, procedureSearchResults: this.props.procedureSearchResults, activeItem: this.props.activeItem, userContext: this.props.userContext, onImprovementUpdate: this.props.onImprovementUpdate, onCodeSearch: this.props.onCodeSearch, onSearchClear: this.props.onSearchClear })] }))] }), this.props.improvement.document_improvement_guid) })));
    };
    return Improvement;
}(react_1["default"].Component));
ImprovementMenu.displayName = 'ImprovementMenu';
var Improvements = /** @class */ (function (_super) {
    __extends(Improvements, _super);
    function Improvements(props) {
        var _this = this;
        var _a;
        _this = _super.call(this, props) || this;
        _this.state = {
            showUnresolved: (_a = props === null || props === void 0 ? void 0 : props.showUnresolved) !== null && _a !== void 0 ? _a : false
        };
        _this.handleImprovementAdd = _this.handleImprovementAdd.bind(_this);
        _this.handleImprovementRemove = _this.handleImprovementRemove.bind(_this);
        _this.handleImprovementUpdate = _this.handleImprovementUpdate.bind(_this);
        _this.toggleFilter = _this.toggleFilter.bind(_this);
        return _this;
    }
    Improvements.prototype.componentDidUpdate = function (prevProps) {
        if (prevProps.showUnresolved !== this.props.showUnresolved) {
            this.setState({
                showUnresolved: this.props.showUnresolved
            });
        }
    };
    Improvements.prototype.handleImprovementAdd = function (improvementDictionaryRow) {
        if (typeof improvementDictionaryRow !== 'undefined') {
            var improvementRequest = {
                processInstance: this.props.processInstance,
                improvementDictionaryRow: improvementDictionaryRow
            };
            this.props.onDocumentImprovementAdd(improvementRequest);
        }
    };
    Improvements.prototype.handleImprovementUpdate = function (improvement) {
        var improvementRequest = {
            processInstance: this.props.processInstance,
            documentImprovement: improvement
        };
        this.props.onDocumentImprovementUpdate(improvementRequest);
    };
    Improvements.prototype.handleImprovementRemove = function (documentImprovement) {
        var improvementRequest = {
            processInstance: this.props.processInstance,
            documentImprovement: documentImprovement
        };
        this.props.onDocumentImprovementRemove(improvementRequest);
    };
    Improvements.prototype.toggleFilter = function (event) {
        var _a;
        event.preventDefault();
        this.setState({
            showUnresolved: !((_a = this.state) === null || _a === void 0 ? void 0 : _a.showUnresolved)
        });
    };
    Improvements.prototype.render = function () {
        var _this = this;
        var props = __assign({}, this.props);
        var improvements = props.improvements, improvementsAction = props.improvementsAction, organization = props.organization, processInstance = props.processInstance;
        var documentImprovements = improvements === null || improvements === void 0 ? void 0 : improvements.improvements;
        var displayedImprovements;
        if (documentImprovements.length === 0) {
            displayedImprovements = ((0, jsx_runtime_1.jsx)("div", __assign({ className: "empty-message" }, { children: "No Document Improvements." })));
        }
        else {
            displayedImprovements = documentImprovements === null || documentImprovements === void 0 ? void 0 : documentImprovements.map(function (improvement, idx) {
                return ((0, jsx_runtime_1.jsx)(Improvement, { improvement: improvement, improvementsAction: _this.props.improvementsAction, organization: organization, processInstance: processInstance, providerSearchResults: improvements.providerSearchResults, procedureSearchResults: improvements.procedureSearchResults, onProviderSearch: _this.props.onProviderSearch, onImprovementRemove: _this.handleImprovementRemove, onSearchClear: _this.props.onSearchClear, onProviderAdd: _this.props.onProviderAdd, onProviderRemove: _this.props.onProviderRemove, onProviderUpdate: _this.props.onProviderUpdate, showAmplifyFeedback: _this.props.showAmplifyFeedback, onImprovementUpdate: _this.props.onDocumentImprovementUpdate, onCodeSearch: _this.props.onCodeSearch, activeItem: _this.props.activeItem, userContext: improvements.userContext, showUnresolved: _this.state.showUnresolved }, idx));
            });
        }
        var filterLabel = "".concat(this.state.showUnresolved ? 'Showing unresolved' : 'Showing all');
        return ((0, jsx_runtime_1.jsxs)("div", __assign({ className: "improvements" }, { children: [(0, jsx_runtime_1.jsx)(conditional_1.Conditional, __assign({ every: [documentImprovements.length > 0] }, { children: (0, jsx_runtime_1.jsxs)("div", __assign({ className: filterLabel.toLowerCase().replace(' ', '-'), onClick: this.toggleFilter }, { children: [(0, jsx_runtime_1.jsx)(conditional_1.Conditional, __assign({ every: [this.state.showUnresolved] }, { children: (0, jsx_runtime_1.jsx)(svg_icons_1.CMXIcon, { svgIconName: "BiomeCheckSVG20", svgIconClass: "unresolved-filter", svgIconSize: "16" }) })), filterLabel] })) })), displayedImprovements, (0, jsx_runtime_1.jsx)(conditional_1.Conditional, __assign({}, improvementsAction, { children: (0, jsx_runtime_1.jsx)(lookup_1.Lookup, { resultFormatter: resultFormatter, getSelectionData: getSelectionData, onSearch: this.props.onDocumentImprovementSearch, 
                        //@ts-ignore
                        onSearchSelection: this.handleImprovementAdd, searchResults: improvements.searchResults, placeholderText: 'Add reason for document improvement', minLength: 1, shouldShowResults: shouldShowResults }) }))] })));
    };
    Improvements.displayName = 'Improvements';
    return Improvements;
}(react_1["default"].Component));
exports.Improvements = Improvements;
//# sourceMappingURL=improvements.js.map